const getOrCreateTooltip = (chart) => {
    let tooltipEl = chart.canvas.parentNode.querySelector('div');

    if (!tooltipEl) {
        tooltipEl = document.createElement('div');
        tooltipEl.className = 'tooltip-box';
        tooltipEl.style.background = '#fff';
        tooltipEl.style.borderRadius = '4px';
        tooltipEl.style.color = '#333';
        tooltipEl.style.opacity = 1;
        tooltipEl.style.pointerEvents = 'none';
        tooltipEl.style.position = 'absolute';
        tooltipEl.style.transform = 'translate(-50%, 0)';
        tooltipEl.style.transition = 'all 0.2s ease-in-out';
        tooltipEl.setAttribute('aria-hidden', 'true');
    
        const table = document.createElement('div');
    
        tooltipEl.appendChild(table);
        chart.canvas.parentNode.appendChild(tooltipEl);
    }
    
    // Add event listener for Escape key to close the tooltip
    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
            tooltipEl.style.opacity = 0;
        }
    });
    
    return tooltipEl;
};

// This function will draw shapes onto a canvas
// The canvas will then be shown inside the tooltip
// The default case is based on our 'square' background color for bar charts, pie charts, ect.
// The other cases are our 6 line chart shapes
function drawShapeOnCanvas(ctx, pointStyle, visualSize, colors) {
    ctx.fillStyle = colors.backgroundColor;
    ctx.strokeStyle = colors.borderColor;
    ctx.lineWidth = colors.borderWidth;

    const drawSize = visualSize * 0.8;
    const offset = (visualSize - drawSize) / 2;

    ctx.beginPath();
    switch (pointStyle) {
        case "circle":
            ctx.arc(visualSize / 2, visualSize / 2, drawSize / 2, 0, 2 * Math.PI);
            break;
        case "rect":
            ctx.rect(offset, offset, drawSize, drawSize);
            break;
        case "triangle":
            ctx.moveTo(visualSize / 2, offset);
            ctx.lineTo(offset + drawSize, offset + drawSize);
            ctx.lineTo(offset, offset + drawSize);
            break;
        case "rhombus":
            ctx.moveTo(visualSize / 2, offset);
            ctx.lineTo(offset + drawSize, visualSize / 2);
            ctx.lineTo(visualSize / 2, offset + drawSize);
            ctx.lineTo(offset, visualSize / 2);
            break;
        case "pentagon":
            let startingAngle = -Math.PI / 2;
            let angleIncrement = 2 * Math.PI / 5;
            ctx.moveTo(
                visualSize / 2 + (drawSize / 2) * Math.cos(startingAngle),
                visualSize / 2 + (drawSize / 2) * Math.sin(startingAngle)
            );
            for (let j = 1; j <= 5; j++) {
                ctx.lineTo(
                    visualSize / 2 + (drawSize / 2) * Math.cos(startingAngle + angleIncrement * j),
                    visualSize / 2 + (drawSize / 2) * Math.sin(startingAngle + angleIncrement * j)
                );
            }
            break;
        case "star":
            let skip = 2;
            let starPoints = 5 * 2;
            let startAngle = -Math.PI / 2;
            for (let point = 0; point < starPoints; point++) {
                let angle = startAngle + (2 * Math.PI / starPoints) * point;
                let radius = point % 2 === 0 ? drawSize / 2 : drawSize / 4;
                let x = visualSize / 2 + Math.cos(angle) * radius;
                let y = visualSize / 2 + Math.sin(angle) * radius;
                if (point === 0) {
                    ctx.moveTo(x, y);
                } else {
                    ctx.lineTo(x, y);
                }
            }
            break;
        default:
            ctx.rect(offset, offset, drawSize, drawSize); // Draw a square by default
            break;
    }
    ctx.closePath();
    ctx.fill();
    if (colors.borderWidth > 0) {
        ctx.stroke();
    }
}

const externalTooltipHandler = (context) => {
    // Tooltip Element
    const {chart, tooltip} = context;
    const tooltipEl = getOrCreateTooltip(chart);

    // Hide if no tooltip
    if (tooltip.opacity === 0) {
        tooltipEl.style.opacity = 0;
        return;
    }
        
    // Set Text
    if (tooltip.body) {
        const titleLines = tooltip.title || [];
        const bodyLines = tooltip.body.map(b => b.lines);
        const contentHeader = document.createElement('div');
        contentHeader.className = 'tooltip-header';

        titleLines.forEach(title => {
            const heading = document.createElement('h4');
        
            // Remove occurrences of {{number}} in the title
            title = title.replace(/\{\{\d+\}\}/g, '');
            // Check if the title contains <sup> tags
            if (title.includes('<sup>')) {
                // If so, set the HTML content directly to interpret the tags
                heading.innerHTML = title;
            } else {
                // Otherwise, treat it as plain text
                const text = document.createTextNode(title);
                heading.appendChild(text);
            }
            
            contentHeader.appendChild(heading);
        });
        
        let total = 0;
        if (chart.config.options.unit == 'percentage') {
            total = chart.config.data.datasets[0].data.reduce((accumulator, currentValue) => accumulator + Number(currentValue), 0);
        }
    
        const contentBody = document.createElement('div');
        contentBody.className = 'tooltip-body';
        
        bodyLines.forEach((body, i) => {
            const colors = tooltip.labelColors[i];
            const pointStyle = tooltip.dataPoints[i].dataset.pointStyle || 'default';
            const canvas = document.createElement('canvas');
            const pixelRatio = window.devicePixelRatio || 1;
            canvas.style.width = '14px';
            canvas.style.height = '14px';
            canvas.width = 16 * pixelRatio;
            canvas.height = 16 * pixelRatio;
            const ctx = canvas.getContext('2d');
            ctx.scale(pixelRatio, pixelRatio);
        
            drawShapeOnCanvas(ctx, pointStyle, 16, colors);
        
            const p = document.createElement('p');
            
            let label, valueString, value;

            if (chart.config.type === 'line') {
                [label, valueString] = body[0].split(": ").map(item => item.trim());
                value = parseFloat(valueString);
                displayText = `${label}: ${value}`;
            } else {
                const bodyParts = body[0].split(": ");
                if (bodyParts.length > 1) {
                    label = bodyParts[0];
                    valueString = bodyParts[1];
                    displayText = body[0];
                } else {
                    valueString = bodyParts[0];
                    label = tooltip.dataPoints[i].label;
                    displayText = `${label}: ${valueString}`;
                }
                const cleanedValueString = valueString.replace(/[^\d.-]/g, '');
                value = parseFloat(cleanedValueString);
            }
        
            // Function to format numeric values with B or M as needed
            const formatNumericValue = (value) => {
                let formattedValue = value;
                let suffix = '';
            
                if (value >= 1e9) {
                    formattedValue = value / 1e9;
                    suffix = 'B'; // Billion
                } else if (value >= 1e6) {
                    formattedValue = value / 1e6;
                    suffix = 'M'; // Million
                }
            
                // Convert to fixed decimals, then parse as float to remove trailing zeroes, finally add suffix
                return parseFloat(formattedValue.toFixed(2)) + suffix;
            };
            
            // Function to format percentages, trimming unnecessary decimal places
            const formatPercentage = (value) => {
                return parseFloat(value.toFixed(2)) + '%'; // Trim unnecessary decimal places, convert to string
            };
            
            // Format the value based on the specified unit
            let formattedValue;
            
            switch (chart.config.options.unit) {
                case 'percentage':
                    formattedValue = formatPercentage(value); // Format as percentage
                    break;
                case 'currency':
                    formattedValue = `$${formatNumericValue(value)}`; // Format as currency
                    break;
                case 'million':
                    formattedValue = formatNumericValue(value * 1e6); // Scale value to millions and format
                    break;
                case 'billion':
                    formattedValue = formatNumericValue(value * 1e9); // Scale value to billions and format
                    break;
                default:
                    formattedValue = formatNumericValue(value); // Use dynamic formatting as default
                    break;
            }
            
            if (chart.config.options.custom_unit) {
                formattedValue = formatNumericValue(value) + chart.config.options.custom_unit; // Format with custom unit
            }
            
            if (chart.config.options.hide_tooltip_unit === 1) {
                formattedValue = value.toString(); // Hide unit if specified in chart options
            }  
            // Construct the tooltip text
            let textContent;

            // Check if the tooltip title (header) contains the label
            const isLabelInTitle = titleLines.some(title => title.includes(label));
            
            if (chart.config.type === 'line') {
                // For line charts, display both the label and the formatted value
                textContent = `${label}: ${formattedValue}`;
            } else if (chart.config.type === 'bar') {
                // For regular bar charts, avoid repeating the label if it's already in the title
                if (!isLabelInTitle) {
                    const bodyParts = body[0].split(": ");
                    if (bodyParts.length > 1) {
                        // If the format includes text and value, use the entire original string and apply formatting to the value part
                        let originalLabel = bodyParts[0];
                        textContent = `${originalLabel}: ${formattedValue}`;
                    } else {
                        // If there's only a value, use the label from the data point and the formatted value
                        textContent = `${label}: ${formattedValue}`;
                    }
                } else {
                    // If the label is already in the title, only display the formatted value
                    textContent = `${formattedValue}`;
                }
            } else {
                // For other chart types or when specific handling is not necessary, just display the formatted value
                textContent = `${formattedValue}`;
            }

            let text = document.createTextNode(textContent);
            p.appendChild(text);
            contentBody.appendChild(canvas);
            contentBody.appendChild(p);
        });

        const tableRoot = tooltipEl.querySelector('div');
        
        // Remove old children
        while (tableRoot.firstChild) {
            tableRoot.firstChild.remove();
        }
    
        // Add new children
        tableRoot.appendChild(contentHeader);
        tableRoot.appendChild(contentBody);
    }

    const {offsetLeft: positionX, offsetTop: positionY} = chart.canvas;
    
    // Display, position, and set styles for font
    tooltipEl.style.opacity = 1;
    tooltipEl.style.left = positionX + tooltip.caretX + 'px';
    tooltipEl.style.top = positionY + tooltip.caretY + 'px';
    tooltipEl.style.font = tooltip.options.bodyFont.string;
    tooltipEl.style.padding = tooltip.options.padding + 'px ' + tooltip.options.padding + 'px';
    tooltipEl.style.zIndex = "1";
    
    // Add more space at the top specifically for bar charts
    if (chart.config.type === 'bar') {
        tooltipEl.style.top = (positionY + tooltip.caretY + 4) + 'px';
    }
};